import { useEffect, useState } from "react";
import { CalendarClock, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { errMsg, useApi } from "@/lib/api";

export default function WeeklyReportPanel() {
  const api = useApi();
  const [cfg, setCfg] = useState(null);
  const [recipients, setRecipients] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/weekly").then((r) => { setCfg(r.data); setRecipients(r.data.recipients.join(", ")); });
  }, [api]);

  const save = async (enabled) => {
    setBusy(true);
    try {
      const r = await api.put("/settings/weekly", { enabled, recipients: recipients.split(/[,;\s]+/).filter(Boolean) });
      setCfg(r.data);
      setRecipients(r.data.recipients.join(", "));
      toast.success("Wochenbericht gespeichert");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  const sendNow = async () => {
    setBusy(true);
    try {
      const r = await api.post("/settings/weekly/send");
      r.data.status === "gesendet" ? toast.success("Wochenbericht versendet") : toast.warning(`Wochenbericht ${r.data.status}: ${r.data.error}`);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="panel h-fit space-y-4 p-6" data-testid="weekly-report-panel">
      <div className="flex items-center gap-2"><CalendarClock className="h-5 w-5 text-orange-600" /><h3 className="text-base font-semibold">Wöchentlicher Marktbericht</h3></div>
      <p className="text-sm text-slate-600">Jeden Montag um 7:00 Uhr: Kursentwicklung Kupfer, Gold, Silber, Aluminium und Stahl, Richtpreise, Hof-Preise und Anlieferungen der letzten 7 Tage – unabhängig von Alarmen.</p>
      {!cfg ? <Loader2 className="h-5 w-5 animate-spin text-orange-600" /> : (
        <>
          <div className="flex items-center gap-3">
            <Switch checked={cfg.enabled} onCheckedChange={(v) => save(v)} disabled={busy} data-testid="switch-weekly-enabled" />
            <Label data-testid="weekly-status">{cfg.enabled ? "Aktiv" : "Aus"}</Label>
          </div>
          <div>
            <Label className="text-xs text-slate-500">Empfänger (mit Komma getrennt)</Label>
            <Textarea rows={3} value={recipients} onChange={(e) => setRecipients(e.target.value)} placeholder="chef@firma.de, einkauf@firma.de" data-testid="input-weekly-recipients" />
          </div>
          <div className="flex flex-wrap gap-2">
            <Button onClick={() => save(cfg.enabled)} disabled={busy} data-testid="btn-save-weekly">Speichern</Button>
            <Button variant="secondary" onClick={sendNow} disabled={busy || cfg.recipients.length === 0} data-testid="btn-send-weekly-now"><Send className="mr-2 h-4 w-4" /> Jetzt senden</Button>
          </div>
        </>
      )}
    </div>
  );
}
